module.exports = __webpack_public_path__ + "img/support.d7541655.svg";